import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import projectColors from "../../../../theme/projectColors";
import HeaderMenu from "./HeaderMenu";
import NavItems from "./Navbar/NavItems";
import navigationRoutes from "./Navbar/navigation";
import ThemeToggle from "../../../common/ThemeToggle";
import LoginDialog from "../../../common/LoginDialog";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { logout } from "../../../../redux/features/auth/authSlice";

function Header() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [loginOpen, setLoginOpen] = useState(false);

  const visibleRoutes = navigationRoutes.filter(
    (nav) => !nav.protected || isAuthenticated
  );

  return (
    <Box width="100%" zIndex={10} mt={1} position="fixed">
      <Container>
        <Box component="header" display="flex" minHeight={40}>
          <Box
            flex={1}
            bgcolor={projectColors.primary.main}
            borderRadius={
              isSmallScreen ? ".5rem 0.5rem 0.5rem 0.5rem" : "0.5rem"
            }
            display="flex"
          >
            <HeaderMenu />
            <Box
              mx={1}
              my={1}
              display="flex"
              justifyContent="center"
              alignContent="center"
              alignItems="center"
            >
              <Link href="/#perfil">
                <Button variant="text" sx={{ color: "white" }}>
                  <Typography variant="body1" fontWeight="bold" color={"white"}>
                    ZavalGT
                  </Typography>
                </Button>
              </Link>
            </Box>
            <Box
              py={1}
              px={2}
              width="100%"
              flex={1}
              display="flex"
              justifyContent="end"
              alignContent="center"
              alignItems="center"
              gap={1}
            >
              <ThemeToggle />
              {isSmallScreen ? (
                <Box />
              ) : (
                <Grid
                  container
                  component="nav"
                  justifyContent="end"
                  columnGap={1}
                >
                  {visibleRoutes.map((nav) => (
                    <NavItems
                      route={nav.route}
                      title={nav.title}
                      key={nav.title}
                    />
                  ))}
                  <NavItems route={"#contactar"} title={"Contactar"} special />
                </Grid>
              )}
              <Button
                variant="outlined"
                size="small"
                startIcon={
                  isAuthenticated ? (
                    <LogoutIcon fontSize="small" />
                  ) : (
                    <LoginIcon fontSize="small" />
                  )
                }
                onClick={() =>
                  isAuthenticated ? dispatch(logout()) : setLoginOpen(true)
                }
                sx={{
                  color: "white",
                  borderColor: "rgba(255,255,255,0.4)",
                  textTransform: "none",
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  "&:hover": {
                    borderColor: "white",
                    bgcolor: "rgba(255,255,255,0.1)",
                  },
                }}
              >
                {isAuthenticated ? "Salir" : "Login"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
      <LoginDialog open={loginOpen} onClose={() => setLoginOpen(false)} />
    </Box>
  );
}

export default Header;
